/* Read-only enhancement: mirror the existing fabric picker in its disclosure. */
(function () {
  'use strict';
  var initialized = new WeakSet();
  var initializedBars = new WeakSet();

  function enhanceReadyBar(bar) {
    if (initializedBars.has(bar)) return;
    var section = document.getElementById(bar.getAttribute('data-kpx-section'));
    var nativePrice = section && section.querySelector('[data-product-price]');
    var nativeAction = section && section.querySelector('form.product-single__form [data-add-to-cart]');
    var output = bar.querySelector('[data-kpx-ready-price]');
    var button = bar.querySelector('[data-kpx-ready-options]');
    if (!section || !nativePrice || !nativeAction || !output || !button) return;
    initializedBars.add(bar);
    document.body.classList.add('kpx-ready-page');
    var queued = false;
    var priceObserver;

    function syncPrice() {
      if (nativePrice.textContent.trim()) output.innerHTML = nativePrice.innerHTML;
    }
    function bindPrice() {
      if (priceObserver) priceObserver.disconnect();
      priceObserver = new MutationObserver(syncPrice);
      priceObserver.observe(nativePrice, { childList: true, subtree: true, characterData: true });
      syncPrice();
    }
    function modalIsOpen() {
      if (document.fullscreenElement || document.querySelector('.drawer--is-open, .modal--is-active, .pswp--open, dialog[open]')) return true;
      return Array.prototype.some.call(document.querySelectorAll('[role="dialog"][aria-modal="true"]'), function (dialog) {
        return dialog.getClientRects().length > 0 && getComputedStyle(dialog).visibility !== 'hidden';
      });
    }
    function update() {
      queued = false;
      if (!bar.isConnected || !section.isConnected) { bar.hidden = true; return; }
      nativeAction = section.querySelector('form.product-single__form [data-add-to-cart]');
      var currentPrice = section.querySelector('[data-product-price]');
      if (!nativeAction || !currentPrice) { bar.hidden = true; return; }
      if (currentPrice !== nativePrice) { nativePrice = currentPrice; bindPrice(); }
      var viewport = window.innerHeight;
      var frame = document.getElementById('PBarNextFrame');
      var frameRect = frame && frame.getBoundingClientRect();
      var previewOffset = frameRect && frameRect.height > 0 && frameRect.top < viewport && frameRect.bottom >= viewport - 2 ? Math.min(frameRect.height, 120) : 0;
      bar.style.setProperty('--kpx-preview-offset', previewOffset + 'px');
      var actionRect = nativeAction.getBoundingClientRect();
      var sectionRect = section.getBoundingClientRect();
      var visibleAction = actionRect.top >= 0 && actionRect.bottom <= viewport - previewOffset && actionRect.height > 0;
      bar.hidden = window.innerWidth > 749 || visibleAction || modalIsOpen() || sectionRect.bottom <= 0 || sectionRect.top >= viewport;
    }
    function schedule() {
      if (!queued) { queued = true; requestAnimationFrame(update); }
    }
    button.addEventListener('click', function () {
      var currentAction = section.querySelector('form.product-single__form [data-add-to-cart]');
      var disclosure = section.querySelector('[data-kpx-fabric-disclosure]');
      var target = (disclosure && disclosure.querySelector('summary')) || currentAction;
      if (!target || !target.isConnected) { bar.hidden = true; return; }
      if (disclosure) disclosure.open = true;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
      target.focus({ preventScroll: true });
      schedule();
    });
    bindPrice();
    var stateObserver = new MutationObserver(schedule);
    stateObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    stateObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('click', schedule, true);
    document.addEventListener('change', schedule, true);
    document.addEventListener('load', schedule, true);
    document.addEventListener('toggle', schedule, true);
    document.addEventListener('fullscreenchange', schedule);
    document.addEventListener('cart:updated', schedule);
    update();
  }

  function enhancePicker(picker) {
    if (initialized.has(picker)) return;
    var disclosure = picker.querySelector('[data-kpx-fabric-disclosure]');
    var property = picker.querySelector('[data-tv-fabric-property]');
    var selectedCopy = picker.querySelector('[data-tv-fabric-selection]');
    var name = picker.querySelector('[data-kpx-fabric-name]');
    var swatch = picker.querySelector('[data-kpx-fabric-swatch]');
    if (!disclosure || !property || !name || !swatch) return;
    initialized.add(picker);

    function syncSummary() {
      var selected = Array.prototype.find.call(picker.querySelectorAll('[data-tv-fabric]'), function (option) {
        return option.getAttribute('data-order-value') === property.value;
      });
      if (!selected) return;
      var arabic = picker.getAttribute('dir') === 'rtl' || /^ar/i.test(document.documentElement.lang || '') || /^ar\./i.test(location.hostname);
      name.textContent = arabic ? selected.getAttribute('data-arabic') : selected.getAttribute('data-order-value');
      var src = selected.getAttribute('data-image');
      if (src) swatch.style.backgroundImage = 'url("' + src.replace(/"/g, '%22') + '")';
      swatch.style.backgroundSize = selected.hasAttribute('data-original') ? 'contain' : 'cover';
    }
    syncSummary();
    // The existing picker updates this attribute as well as the native checked radio.
    new MutationObserver(syncSummary).observe(property, { attributes: true, attributeFilter: ['value'] });
    if (selectedCopy) new MutationObserver(syncSummary).observe(selectedCopy, { childList: true, characterData: true, subtree: true });
    picker.addEventListener('change', syncSummary);
    var done = picker.querySelector('[data-kpx-fabric-done]');
    if (done) done.addEventListener('click', function () {
      disclosure.open = false;
      var summary = disclosure.querySelector('summary');
      if (summary) summary.focus({ preventScroll: true });
    });
  }

  function init(scope) {
    if (!document.body.classList.contains('klik-transformation')) return;
    scope.querySelectorAll('[data-tv-fabric-picker]').forEach(enhancePicker);
    scope.querySelectorAll('[data-kpx-ready-bar]').forEach(enhanceReadyBar);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('quickview:loaded', function () { init(document); });
})();
